import PropTypes from 'prop-types';

export const UpArrowIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M18.0089 11.5618C17.4749 12.0653 16.6509 12.0501 16.1322 11.5313L13.6299 9.029L13.6299 18.6567C13.6299 19.4044 13.0348 19.9994 12.2872 19.9994C11.5395 19.9994 10.9445 19.4044 10.9445 18.6567L10.9445 9.029L8.44219 11.5313C7.92342 12.0501 7.0995 12.0501 6.56547 11.5618C6.01619 11.043 6.00094 10.1733 6.53496 9.63932L12.2719 3.90234L18.0089 9.63932C18.5429 10.1733 18.5277 11.043 17.9784 11.5618L18.0089 11.5618Z"
        fill="#27AE60"
      />
    </svg>
  );
};

UpArrowIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
